import {
  moveDownLeft,
  moveUpLeft,
  moveLeft,
  moveDownRight,
  moveUpRight,
  moveRight,
  moveUp,
  moveDown,
  pause,
  wild,
} from "./behaviours";

import { getRandomFromArray } from "utils";

import { useEffect, useState } from "react";
import { useCollision } from "./use-collision";
import { usePosition } from "./use-position";
import { useWorld } from "./use-world";
import { Sprite } from "./sprite";

const behaviours = [
  moveDownLeft,
  moveUpLeft,
  moveLeft,
  moveDownRight,
  moveUpRight,
  moveRight,
  moveUp,
  moveDown,
  pause,
];

export const Character = ({
  x = 32,
  y = 32,
  width = 32,
  height = 32,
  config = {},
  ...rest
}) => {
  const cfg = {
    destination: null,
    initialBehaviour: getRandomFromArray(behaviours),
    solid: true,
    stride: 1,
    ...config,
  };
  const [collisions, setCollisions] = useState({ count: 0 });
  const [moving, setMoving] = useState();
  const [paused, setPaused] = useState();
  const [behaviour, setBehaviour] = useState(() => cfg.initialBehaviour);
  const [position, update] = usePosition(x, y, width, height, cfg);
  const [sprite, setSprite] = useState(position);
  const { frame, sprites, setDialog, screen } = useWorld();
  const { isColliding } = useCollision(screen);
  const changeMovement = () => {
    setBehaviour(() => getRandomFromArray(behaviours));
  };

  const action = () => {
    const nextPos = behaviour(position, cfg.stride);
    const colliding = isColliding(nextPos, sprites);
    if (!colliding) {
      update(nextPos.x, nextPos.y);
      return setCollisions({ count: 0 });
    } else {
      if (colliding.position.id === "player") {
        setBehaviour(behaviours[8]);
      } else {
        setCollisions({ sprite: colliding, count: collisions.count + 1 });
        changeMovement();
      }
    }
  };

  useEffect(() => {
    if (
      sprite?.position?.interacting &&
      sprite.position.dialog.length > 0 &&
      !paused
    ) {
      setPaused(true);
      setDialog(sprite.position.dialog || ["what?"]);
    } else if (
      sprite?.position?.interacting &&
      sprite.position.dialog.length === 0 &&
      paused
    ) {
      setPaused(false);
    }
  }, [sprite]);

  useEffect(() => {
    if (collisions.count > 3) {
      const offsets = [
        { x: width, y: 0 },
        { x: -width, y: 0 },
        { x: 0, y: height },
        { x: 0, y: -height },
        { x: width, y: height },
        { x: -width, y: -height },
        { x: width, y: -height },
        { x: -width, y: height },
      ];
      const collidedWith = collisions.sprite.position;
      for (const offset of offsets) {
        const unstuckPos = {
          ...position,
          x: collidedWith.x + offset.x,
          y: collidedWith.y + offset.y,
        };
        if (!isColliding(unstuckPos, sprites)) {
          update(unstuckPos.x, unstuckPos.y);
          setCollisions({ count: 0 });
          return;
        }
      }
      setCollisions({ count: 0 });
    }
  }, [collisions]);

  useEffect(() => {
    setMoving(!moving);
    setSprite(sprites[position.id]);
  }, [frame]);

  useEffect(() => {
    if (moving && !paused) {
      action();
    }
  }, [moving]);

  useEffect(() => {
    const update = setTimeout(changeMovement, 5000);
    return () => clearTimeout(update);
  }, [behaviour]);

  return (
    <>
      <Sprite position={position} {...rest} />
    </>
  );
};
